import { render, staticRenderFns } from "./oneClickBeautyTransformation.vue?vue&type=template&id=65734f7a&scoped=true"
import script from "./oneClickBeautyTransformation.vue?vue&type=script&lang=js"
export * from "./oneClickBeautyTransformation.vue?vue&type=script&lang=js"
import style0 from "./oneClickBeautyTransformation.vue?vue&type=style&index=0&id=65734f7a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65734f7a",
  null
  
)

export default component.exports